import { Outlet } from "react-router-dom";
import React from "react";
import routes from "../routes";
import { generateChildren } from "./RouterGenerator";

const { auth } = routes;

let ghostChildren = generateChildren([
  auth().reset,
  auth().register,
  auth().login,
  auth().lost,
]);

export const routerGhost = [
  {
    path: auth().path,
    element: <Outlet />,
    children: ghostChildren,
  },
];
